import { Component, ElementRef, ViewChild } from '@angular/core';
import { MaterialPage } from '../../../../components/page/material-page.component';
import { Meta, Title } from '@angular/platform-browser';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AlertService } from 'src/app/_services';
import { GreenBoxService } from '../../services/greenbox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';

@Component({
  templateUrl: './green-box-page.component.html',
  styleUrls: ['./green-box-page.component.scss']
})
export class GreenBoxPageComponent extends MaterialPage {

  @ViewChild('whatCanIPut', { read: ElementRef }) whatCanIPutPanel: ElementRef;
  @ViewChild('fees', { read: ElementRef }) feesPanel: ElementRef;
    
  greenBoxRequestForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
  });
  
  canSubmitForm: boolean = false;
  expandFAQSection: string | null;
    
  constructor(
    private greenBoxService: GreenBoxService,
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    sidenavService: SidenavService,
    private router: Router,
    private alertService: AlertService,
    private route: ActivatedRoute
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:GreenBox`,
      $localize `:page description:The most convenient way to get rid of everything you no longer need in a profitable and environmentally conscious way.`,
      true);
  }
  
  ngAfterViewInit() {
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.expandFAQSection = fragment;
        setTimeout(() => this.scrollToElement(fragment), 100);
      }
    });
  }
  
  scrollToElement(id: string) {
    
    switch (id) {
      case 'whatCanIPut':
        this.scrollToPanelHeader(this.whatCanIPutPanel);
        break;
      case 'fees':
        this.scrollToPanelHeader(this.feesPanel);
        break; 
    }
  }
  
  private scrollToPanelHeader(header: ElementRef) {
    //panelBody.setAttribute('style', 'background-color: green');
    const elementPosition = header.nativeElement.getBoundingClientRect().top + window.scrollY - 120;

    // Smoothly scroll to the adjusted position in one motion
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  }
  
  onFragmentClick(fragment: string, event: Event) {
  
    event.preventDefault();
  
     if (this.expandFAQSection === fragment) {
       this.scrollToElement(fragment);
     } else {
       this.router.navigate([], { fragment: fragment });
     }
   }
  
  async sendRequest() {
    
    if (this.greenBoxRequestForm.invalid) {
        console.log("Form invalid");
        return;
    }
    
    try {
      await this.greenBoxService.createGreenBoxRequest({
          name: this.greenBoxRequestForm.controls["name"].value!,
          address: this.greenBoxRequestForm.controls["address"].value!,
          email: this.greenBoxRequestForm.controls["email"].value!,
          phone: this.greenBoxRequestForm.controls["phone"].value!
      });
    } catch {
      this.alertService.showError($localize  `Something went wrong`);
      return;
    }

    this.alertService.showSuccess($localize `Box requested`);
    this.router.navigate(['/'])
  }
  
  toggleFormSubmitAvailability(enabled: boolean) {
    this.canSubmitForm = enabled;
  }
}